import { Context } from "types";

export const getServices =
  ({ apiClient }: Context) =>
  () =>
    apiClient<App.Domain.API.Services.Resources.ServicesResource>({
      url: "/services",
      method: "GET",
    });
